import React from 'react';

class StaticRadioFormType extends React.Component {
    render() {
        var types = this.props.types;

        if(types.length > 9){

            var i,j,types2,chunk = 5;
            for (i=0,j=types.length; i<j; i+=chunk) {
                types2 = types.slice(i,i+chunk);
            }
            types = types.slice(0, 5);
        }

        return (
            <div>
                <div className="col-dt-50 col-tbl-full">
                    <StaticRadioList elements={types} onOptionalAttributeChanged={(name, state) => this.props.onOptionalAttributeChanged(name, state)} checkedAttributes={this.props.checkedAttributes}/>
                </div>
                <div className="col-dt-50 col-tbl-full col-padding-left">
                    {types2 !== undefined && types2.length > 0 &&
                    <StaticRadioList elements={types2} onOptionalAttributeChanged={(name, state) => this.props.onOptionalAttributeChanged(name, state)} checkedAttributes={this.props.checkedAttributes}/>
                    }
                </div>
            </div>
        );
    }
}

class StaticRadioList extends React.Component {
    render() {
        const _this = this;

        var radioElements = this.props.elements.map(function(element) {

            var checked = false;

            if(_this.props.checkedAttributes !== null && element.input_name in _this.props.checkedAttributes && _this.props.checkedAttributes[element.input_name] === element.value){
                checked = true;
            }

            return (
                <StaticRadioElement key={element.input_name + element.value} input_name={element.input_name} value={element.value} checked={checked} name={element.name} onOptionalAttributeChanged={(name, state) => _this.props.onOptionalAttributeChanged(name, state)} checkedAttributes={_this.props.checkedAttributes} />
            );
        });
        return (
            <div className="neutrik-radio">
                {radioElements}
            </div>
        );
    }
}

class StaticRadioElement extends React.Component {

    onValueChanged(e) {
      this.props.onOptionalAttributeChanged(this.props.input_name, this.props.value);
    }

    onValueClick(input_name, value){

        //UNCHECK IF CLICKED TWICE
        if(this.props.checkedAttributes !== null && input_name in this.props.checkedAttributes && this.props.checkedAttributes[input_name] === value){
            this.props.onOptionalAttributeChanged(input_name, null);
        }
    }

    render() {
        return (
            <div className="neutrik-radio">
                <input type="radio" name={this.props.input_name} value={this.props.value} id={this.props.input_name + "_" + this.props.value} onChange={(e) => this.onValueChanged(e)} onClick={(input_name, value) => this.onValueClick(this.props.input_name, this.props.value)} checked={this.props.checked}/>
                <label htmlFor={this.props.input_name + "_" + this.props.value}>{this.props.name}</label>
            </div>
        );
    }
}

export default StaticRadioFormType;


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/components/StaticRadioFormType.js